import { InputAdornmentClassKey } from '@material-ui/core/InputAdornment';

const MuiInputAdornment = (): Partial<Record<InputAdornmentClassKey, unknown>> => ({
    root: {
        '&$positionStart:not($marginDense):not($hiddenLabel)': {
            marginTop: 16,
        },
    },
});

export default MuiInputAdornment;
